import { useEffect, useState } from "react";

function WhyChooseUs() {
  const [years, setYears] = useState(0);
   const [installations, setInstallations] = useState(0); // ✅ IMPORTANT
  const [support, setSupport] = useState(0);

 useEffect(() => {
    const interval = setInterval(() => {

      setYears(prev => (prev < 5 ? prev + 1 : 5));

      setInstallations(prev => {
        console.log("Installations:", prev)
        if (prev >= 500) return 500;
        return prev + 25;
      });

      setSupport(prev => (prev < 24 ? prev + 1 : 24));

    }, 50);


    return () => clearInterval(interval);
  }, []);

  return (
    <div className="why-section">
      <h1>Why Choose Us</h1>

      <div className="why-container">
        <div className="why-card">
          <h2>{years}+</h2>
          <p>Years Experience</p>
        </div>

        <div className="why-card">
          
          <h2>{installations}+</h2>
          <p>Installations</p>
        </div>

        <div className="why-card">
          <h2>✔</h2>
          <p>Govt Approved</p>
        </div>

        <div className="why-card">
          <h2>{support}/7</h2>
            <p>Support</p>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;